import { render, staticRenderFns } from "./CompanyGroup.vue?vue&type=template&id=7b6298ac&scoped=true"
import script from "./CompanyGroup.vue?vue&type=script&lang=js"
export * from "./CompanyGroup.vue?vue&type=script&lang=js"
import style0 from "./CompanyGroup.vue?vue&type=style&index=0&id=7b6298ac&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6298ac",
  null
  
)

export default component.exports